import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { campaignJobBoardQueryKeys } from "./queryKeys";

import { instance } from "@/lib/axios/instance";
import { CampaignJobBoardType } from "@/types/response/CampaignJobBoardType";
import { PagedResponse } from "@/types/response/PagedResponse";

interface UseCampaignJobBoardsInfiniteParams {
  campaignId: string;
  clientId?: string;
  statuses?: string[];
  search?: string;
}

export function useCampaignJobBoardsInfinite(
  params: UseCampaignJobBoardsInfiniteParams
) {
  return useInfiniteQuery<PagedResponse<CampaignJobBoardType>, AxiosError>({
    queryKey: campaignJobBoardQueryKeys.infinite(
      params.campaignId,
      params.clientId,
      params.statuses,
      params.search
    ),
    enabled: !!params.campaignId,
    refetchOnMount: true,
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      instance
        .get<PagedResponse<CampaignJobBoardType>>(
          `/api/v2/Campaigns/${params.campaignId}/Integrations`,
          {
            params: {
              clientId: params.clientId,
              page: pageParam,
              pageSize: 10,
              statuses: params.statuses && params.statuses.length > 0 ? params.statuses : undefined,
              search: params.search || undefined,
            },
          }
        )
        .then((res) => res.data),
    getNextPageParam: (lastPage, allPages) => {
      const totalRecords = lastPage.totalRecords;
      const totalFetched = allPages.reduce(
        (acc, page) => acc + page.data.length,
        0
      );
      return totalFetched < totalRecords ? allPages.length + 1 : undefined;
    },
    placeholderData: keepPreviousData,
  });
}
